module.exports = __webpack_public_path__ + "img/india.2e1524c8.svg";